import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface MobileOptimizedCardProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
  compact?: boolean;
}

export const MobileOptimizedCard = ({
  title,
  description,
  children,
  className,
  headerClassName,
  contentClassName,
  compact = false
}: MobileOptimizedCardProps) => {
  return (
    <Card className={cn(
      'touch-target tap-highlight-none',
      className
    )}>
      {(title || description) && (
        <CardHeader className={cn(
          compact ? 'pb-3 sm:pb-4' : 'pb-4 sm:pb-6',
          headerClassName
        )}>
          {title && (
            <CardTitle className={cn(
              'mobile-subheading',
              compact && 'text-base sm:text-lg'
            )}>
              {title}
            </CardTitle>
          )}
          {description && (
            <CardDescription className="mobile-body">
              {description}
            </CardDescription>
          )}
        </CardHeader>
      )}
      <CardContent className={cn(
        'card-responsive',
        contentClassName
      )}>
        {children}
      </CardContent>
    </Card>
  );
};